
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class NodiDialog extends Serenity.EntityDialog<NodiRow, any> {
        protected getFormKey() { return NodiForm.formKey; }
        protected getIdProperty() { return NodiRow.idProperty; }
        protected getLocalTextPrefix() { return NodiRow.localTextPrefix; }
        protected getNameProperty() { return NodiRow.nameProperty; }
        protected getService() { return NodiService.baseUrl; }
        protected getDeletePermission() { return NodiRow.deletePermission; }
        protected getInsertPermission() { return NodiRow.insertPermission; }
        protected getUpdatePermission() { return NodiRow.updatePermission; }
        
        protected form = new NodiForm(this.idPrefix);

        afterLoadEntity() {
            if (this.isNew()) {
                if (this.idChecklist > 0) {
                    this.form.IdChecklist.value = this.idChecklist.toString();
                    Serenity.EditorUtils.setReadOnly(this.form.IdChecklist, true);
                }
            }
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();

            //
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "undo-delete-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "localitation-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "clone-button"), 1);

            //
            return buttons;
        }

        ///////////////////////////////////
        private _idChecklist: number;

        get idChecklist() {
            return this._idChecklist;
        }

        set idChecklist(value: number) {
            if (this._idChecklist != value) {
                this._idChecklist = value;
            }
        }
    }
}